import React, { FC } from 'react';
import styled from 'styled-components';
import { CommonComponentProps } from '@clds/common-definitions';
import { globalTheme } from '@clds/component-theme';
import { ButtonMenu } from '@cld/button';
import { Icon } from '@cld/icon';

export type AdvancedButtonMode = 'expanded' | 'collapsed';

export interface SearchFieldButtonsProps extends CommonComponentProps<'div'> {
  /**
   * Indicates advanced search panel visibility by showing arrow down icon
   */
  advancedButtonMode?: AdvancedButtonMode;
  /**
   * Called on advanced button click
   */
  onAdvancedButtonClick?: () => void;
  /**
   * Called on search button click
   */
  onSearchButtonClick?: () => void;
  /**
   * Called on clear button click
   */
  onClearButtonClick?: () => void;
  /**
   * Tells whether value is empty
   */
  isEmptySearchField?: boolean;
}

const StyledIconList = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;

  ${ButtonMenu} {
    padding: ${globalTheme.spacing.sm};
    height: auto;
  }
`;

/**
 * Set of buttons to use in search component
 */
export const SearchFieldButtons: FC<React.PropsWithChildren<SearchFieldButtonsProps>> = ({
  advancedButtonMode = 'collapsed',
  onAdvancedButtonClick,
  onSearchButtonClick,
  onClearButtonClick,
  isEmptySearchField = true,
}) => (
  <StyledIconList>
    {advancedButtonMode && onAdvancedButtonClick && (
      <ButtonMenu data-test="advanced-button" shape="solid" size="sm" onClick={onAdvancedButtonClick}>
        <Icon name="tune" />
        <Icon name={advancedButtonMode === 'collapsed' ? 'arrowDropDown' : 'arrowDropUp'} />
      </ButtonMenu>
    )}
    {isEmptySearchField ? (
      <ButtonMenu data-test="search-button" shape="solid" size="sm" onClick={onSearchButtonClick}>
        <Icon name="search" />
      </ButtonMenu>
    ) : (
      <ButtonMenu data-test="clear-button" shape="solid" size="sm" onClick={onClearButtonClick}>
        <Icon name="cross" />
      </ButtonMenu>
    )}
  </StyledIconList>
);
